export class AppColors {
    static readonly primary = '#159ed8'
    static readonly secondary = '#cf2026'
    static readonly accent = '#00bcd4'
    static readonly error = '#ff5722'
    static readonly warning = '#ffeb3b'
    static readonly info = '#607d8b'
    static readonly success = '#4caf50'

    static readonly logoBlue = '#159ed8'
    static readonly logoBlue2 = '#015094'
}